import { FONT_TYPE, STATIC_TYPE, KEYFRAME_TYPE, RULE_TYPE } from './styleTypes';

export default {
  fontFaces: FONT_TYPE,
  statics: STATIC_TYPE,
  keyframes: KEYFRAME_TYPE,
  rules: RULE_TYPE
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/sheetMap.js
// module id = 823
// module chunks = 1